module.exports = __webpack_public_path__ + "49056ddc45185717dcb615f95b3cff4f.pdf";